import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  birthdayIconContainer: { backgroundColor: '#FFEFE3', display: 'inline-block' },
  birthdayIcon: { color: '#FF872E', width: '24px', height: '24px' },
}));
